export function getScrollableParent(node: Node | null): HTMLElement | null {
  const overflowY = node instanceof HTMLElement && window.getComputedStyle(node).overflowY;
  const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
  if (!node) {
    return null;
  } else if (isScrollable && node instanceof HTMLElement && node.scrollHeight >= node.clientHeight) {
    return node;
  }

  return getScrollableParent(node.parentNode) || document.body;
}
